<template>
    <div class="list-main">
        <div class="list-header">
            <div class="header-box fl">
                <div class="title">政策措施</div>
            </div>
            <a-input class="input fr" placeholder="请输入关键字" v-model="keyword">
                <a-icon slot="suffix" type="search" @click="searchHandler"/>
            </a-input>
        </div>

        <div class='list-body'>
            <div class='item' v-for="item ,index in list" :key="index" @click="$router.push({path:'/newHome/measure/detail',query:{newId:item.newId}})">
                <div class="drop fl"></div>
                <div class="title fl">{{ item.newName }}</div>
                <div class="time fr">{{ item.addTime }}</div>
            </div>
        </div>

        <div class="pagination">
            <a-pagination v-model="current" :total="total" show-quick-jumper :show-total="total => `共有 ${total} 条信息`" :item-render="itemRender" @change="changeHandler"/>
        </div>
        <div style="height: 20px;"></div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            type : 3,
            keyword: '',
            total:0,
            list:[],
            current:1,
        };
    },

    mounted() {
        this.getList()
    },

    methods: {
        changeHandler(current,size){
            this.current = current
            this.getList()
        },
        searchHandler(){
            this.current = 1
            this.getList()
        },
        getList(){
            const params={
                currentPage:this.current,
                newName:this.keyword,
                type:this.type
            }
            this.$http.getNews(params).then(res=>{
                if(res.success){
                    this.total = res.page.allSize;
                    this.list = res.newList;
                    this.currentPage = res.page.currentPage;
                }
            })
        },
        itemRender(current, type, originalElement){
            if (type==='prev'){
                return <a>上一页</a>
            }else if(type==='next'){
                return <a>下一页</a>
            }
            return originalElement;
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/home/news.scss";
</style>